/*
 * @Description: 
 * @version: 
 * @Author: xia zai hai
 * @Date: 2025-09-02
 * @LastEditors: xia zai hai
 * @LastEditTime: 2025-09-18
 */
import { TokenManagerConfig,AccessTokenResult,TokenResult } from './types';

/**
 * 获取 accessToken
 * @param config 配置对象
 * @returns Promise<string | null> 返回 accessToken，失败时返回 null
 */
export async function getAccessToken(config: TokenManagerConfig, arg: any = {}): Promise<AccessTokenResult | TokenResult | null> {
  if (!config?.tokenEndpoint) {
    return null;
  }

  try {
    const response = await fetch(config.tokenEndpoint, {
      method: config.method || 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...(config.headers || {}),
      },
      
      credentials: 'include',
      redirect:'manual',
        ...arg
    });
    console.log('响应状态:', response);
  const contentType = response.headers.get('content-type');
      console.log('响应状态:', response);
      if (contentType && contentType.includes('application/json')) {
        const { data } = await response.json();
        return data || null;
      }
      if (response.redirected) {
        return {
          url: response.url,
          code:'301'
        } 
      }
      return null;
  } catch {
    return null;
  }
}
